module.exports = __webpack_public_path__ + "89a1bd48aba292ec60a27bc633702bd7.pdf";